import { useNavigate } from 'react-router-dom'
import { Box, VStack } from '@chakra-ui/react'
import { useAtom } from 'jotai'
import { monthlyCourseIdAtom, payTypeAtom, restoreOrderIdAtom } from '@!/atoms/paymentAtom'
import { usePaymentValidation, useMonthlyCourseRegister } from '@!/User/Payment/Hooks'
import { PaymentHeader, PageBackLink, CreditCardInfo } from '@!/User/Payment/components'
import { CircularProgressModal } from '@!/components/Modal'
import { PayTypeContent } from '@!/User/Payment/components/MonthlyCourse'
import NoticeList from '@!/User/Payment/components/MonthlyCourse/NoticeList'
import MonthlySubmitButton from '@!/User/Payment/components/MonthlySubmitButton'

export const PaymentConfirm = ({ restore }) => {
  usePaymentValidation()

  const navigate = useNavigate()
  const [monthlyCourseId] = useAtom(monthlyCourseIdAtom)
  const [restoreOrderId] = useAtom(restoreOrderIdAtom)
  const [payType] = useAtom(payTypeAtom)

  const { executeRegister, isRegistering } = useMonthlyCourseRegister()

  const handleRegister = (payType) => {
    executeRegister(payType, monthlyCourseId, restoreOrderId, restore)
  }

  const handleChangeCard = (e) => {
    e.preventDefault()
    navigate('/monthly_course/new_card')
  }

  const pageBack = (e) => {
    e.preventDefault()
    navigate(-1)
  }

  return (
    <VStack maxW={'600px'} m={'auto'} spacing={6}>
      <VStack w={'full'} spacing={4}>
        <Box w={'full'} px={4}>
          <PaymentHeader />
        </Box>

        {payType === 'credit' && (
          <Box w={'full'} px={4}>
            <CreditCardInfo handleChangeCard={handleChangeCard} />
          </Box>
        )}

        <Box w={'full'}>
          <Box bg={'gray.100'} px={4} py={2} mb={3} fontWeight={'bold'}>
            決済方法
          </Box>

          <Box px={4}>
            <PayTypeContent payType={payType} showIcon={false} />
          </Box>
        </Box>
      </VStack>

      <NoticeList restore={false} />
      <Box w={'full'} px={4}>
        <MonthlySubmitButton handleSubmit={() => handleRegister(payType)} restore={restore} />
      </Box>

      <PageBackLink pageBack={pageBack} />
      <CircularProgressModal isOpen={isRegistering} />
    </VStack>
  )
}

export default PaymentConfirm
